import React from 'react';
import { IconButton, Tooltip, makeStyles } from '@material-ui/core';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import { documentHelpers } from '../../helpers';
import { DownloadIcon } from '../../assets/icons';

const useStyles = makeStyles((theme) => ({
  downloadIcon: {
    color: theme.palette.primary.dark,
  },
  iconButton: {
    color: theme.palette.primary.dark,
    padding: 6,
    textDecoration: 'none',
  },
}));

const DownloadDocument = ({ document, actualVersion, iconClassName }) => {
  const classes = useStyles();
  const intl = useIntl();
  const downloadLabel = intl.formatMessage({ id: 'app.download', defaultMessage: 'Descargar' });

  return (
    <Tooltip title={downloadLabel}>
      <IconButton
        className={classes.iconButton}
        onClick={() => documentHelpers.handleDownloadDocument(document, actualVersion)}
      >
        <DownloadIcon className={iconClassName || classes.downloadIcon} />
      </IconButton>
    </Tooltip>
  );
};

DownloadDocument.propTypes = {
  document: PropTypes.shape({}).isRequired,
  actualVersion: PropTypes.shape({}).isRequired,
  iconClassName: PropTypes.string,
};

DownloadDocument.defaultProps = {
  iconClassName: '',
};

export default DownloadDocument;
